export default class User {
  public constructor (init?:Partial<User>) {
    Object.assign(this, init)
  }

  public id = '';
  public email = '';
  public firstName = '';
  public lastName = '';
  public isFirstLogin = false;
  public profilePicture = '';
  public companyLogo = '';
  public companyColor = '';
}
